import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'
import api from 'src/services/api'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import objectToQueryString from 'src/helpers/object-to-query-string'

import * as AuditsActions from './actions'

import { ResponseDataRequests } from '../requests/types'
import * as RequestsActions from '../requests/actions'

const PAGE_SIZE = 10

export function* getAudits({
  payload: { options }
}: ReturnType<typeof AuditsActions.getAudits>) {
  try {
    const {
      audits,
      me: { organization }
    } = yield select((state: ApplicationState) => state)

    const filterNumbers = audits.filterRequestNumber && {
      request_numbers: audits.filterRequestNumber
    }

    const filterTravelerName = audits.filterRequestTravelerName && {
      traveler_name: audits.filterRequestTravelerName
    }

    const queryString = objectToQueryString(
      Object.assign(
        {
          auditor_view: 'TRUE',
          page_size: PAGE_SIZE,
          page: options.page || 1,
          ...(filterNumbers || {}),
          ...(filterTravelerName || {})
        },
        ...audits.filterStatus.map((status: string) => ({
          [status]: 'TRUE'
        }))
      )
    )

    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `organizations/${organization.organization_id}/requests${queryString}`
    )

    if (response.ok) {
      yield put(AuditsActions.getAuditsSuccess(response.data))
      yield put(
        RequestsActions.setRequestTotals({
          request_totals: {
            ...response.data.request_totals,
            total_audits: response.data.total_results
          }
        })
      )
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(AuditsActions.getAuditsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getAudits', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(AuditsActions.getAuditsFailure(message))
  }
}
